module.exports = __webpack_public_path__ + "media/images/emblems/Benken_SG_blazono-2597a11c67b733a8abd82486a603d615.png";